export default __webpack_public_path__ + "static/logo-a9774f73c8c1c7b7ec522a0c0144ecf4.svg";